import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
const TeamFour = () => {
  const swiperRef = useRef();

  return (
    <>
      {/* Team area start */}
      <section className="team__area-5 pt-150 swiper">
        <div className="row">
          <div className="col-lg-4">
            <div className="team__left-5" data-aos="fade-up">
              <h3 className="team__sub-5" style={{ color: "black" }}>
                SON EĞİTİM
              </h3>
              <h2
                className="team__title-5"
                style={{ color: "black", fontSize: 50 }}
              >
                <span>FAALİYETLERİMİZ</span>
              </h2>
              <div
                className="testimonial-five-prev cursor"
                onClick={() => swiperRef.current?.slidePrev()}
              >
                <i className="fa-solid fa-chevron-left" />
              </div>
              <div
                className="testimonial-five-next cursor"
                onClick={() => swiperRef.current?.slideNext()}
              >
                <i className="fa-solid fa-chevron-right" />
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className=" team-active-5">
              <div>
                <Swiper
                  spaceBetween={20}
                  modules={[Navigation]}
                  onBeforeInit={(swiper) => {
                    swiperRef.current = swiper;
                  }}
                  slidesPerView={1}
                  breakpoints={{
                    768: {
                      slidesPerView: 2,
                    },
                    992: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                >

<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/alfa.jpeg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DaLPIz5iJwr/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
29.06.2026 Tarihinde @alfasolarenerji Firmamızın Kırıkkale’de Bulunan Güney Fabrikasında İlgili Personellere Yönelik “YYS Güvenlik Eğitimini” Gerçekleştirdik.                            </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>


<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/dohler.jpeg" alt="Member " />
                          <Link
                            to="#https://www.instagram.com/securitr.as/p/DZpqB_WoMXT/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                              21/22.05.2026 Tarihinde @doehlerturkiye de İlgili Personele Yönelik “Tedarik Zinciri Güvenliği Eğitimini” Gerçekleştirdik
                            </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>


<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/kas.jpeg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DXhAK9RiPwW/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                            24.04.2026 Tarihinde Bugün @kaskayalargrup Gebze OSB de Bulunan Fabrikasında İlgili Personellere Yönelik "Tedarik Zinciri Güvenliği Eğitimini" Gerçekleştirdik
                         </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>


<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/ikra.jpeg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DWuPGDWCKQF/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                            04.04.2026 Tarihinde @ikralojistik Tuzla Yerleşkede 2019/2022 den Sonra Bu Yılda İlgili Personellere Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik
                         </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/bogazici.jpeg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DUtLGuZiMuU/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                            13.02.2026 Tarihinde Sayın Cumhurbaşkanımızın Teşriflerine Denk Gelen Bu Özel Günde @unibogazici de Devam Eden Güvenlik Eğitimleri Kapsamında 8. Hafta Eğitimlerimizde İlgili Personellere  Yönelik "Suçlu Profili İnceleme Eğitimini" Hisar Kampüsünde Gerçekleştirdik.
<br/>
Bu Eğitimle Birlikte 8 Hafta Süren Güz Eğitim Dönemimizi de Tamamlamış Olduk. Yaz Döneminde Görüşmek Dileğiyle
                         </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/els.jpeg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DSaaN0JiF1u/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          18.12.2025 Tarihinde Yerinde Gümrükleme ve YYS Belgesi Sahibi Ender Lojistik Firmalarımızda  @elslogcom da Tekrarlama Eğitimleri Kapsamında İlgili Personellere Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/emsa.jpeg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DRH30EsiJrf/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          11.11.2025 Tarihinde @emsajenerator'de İlgili Personellere Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>


<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/Kaplanser.jpeg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DQTaocbiKXO/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          27.10.2025 Tarihinde 5 Yıl Aradan Sonra @kaplansercarpet Firmamızda Hatırlatma Eğitimlerinde İlgili Personele Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/tumad-all.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DNVvzA0s8YK/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          10/11 Temmuz 2025 Tarihlerinde TÜMAD Madencilikte YYS Hatırlatma Eğitimleri Kapsamında "YYS Güvenlik Eğitimleri" @teams Üzerinden Gerçekleştirilmiştir
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/bogaz-ici-5.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DNVuk3jsbKY/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          11 Temmuz 2025 günü  @unibogazici de Devam Eden Eğitim Faaliyetlerimiz Kapsamında 6. Grup Özel Güvenlik Yönetici ve Personellerine Yönelik "Suçlu Profili İnceleme ve Tespiti Eğitimini" Tarihi Kırmızı Yalıda Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>






<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/cke-kimya-all.jpg" alt="Member " />
                          <Link
                            to="#"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          10 Temmuz 2025 Tarihinde @cukurovakimya.official Firmamızın YYS Dönem Değerlendirmesinde @teams Üzerinden İlgili Personellere Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/fortrans-all.jpg" alt="Member " />
                          <Link
                            to="#"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          30 Haziran 2025 Tarihinde YYS Süreçlerinde Yıllara Saki Çözüm Ortağımız Fortrans Lojistikte İlgili Personele Yönelik "YYS Güvenlik Eğitimi" Gerçekleştirilmiştir
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/cimsatas-all.jpg" alt="Member " />
                          <Link
                            to="#"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          04 Temmuz 2025 tarihinde Mersin'imizin Güçlü Sanayi Firması ÇİMSATAŞ da YYS Tekrarlama Eğitimleri Kapsamında İlgil Personele Yönelik "YYS Güvenlik Eğitimlerini" İki Grup Halinde Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>




<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/akpa-all.jpg" alt="Member " />
                          <Link
                            to="#"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          @akpaaluminyum Firmamızın Devam Eden YYS Süreçleri Kapsamında;
<br></br>
23 Haziran Tarihinde 2 Grup Halinde "YYS Güvenlik Eğitimi"<br></br>
28/29 Haziran Tarihinde "YYS Risk Analiz Raporu Çalışması"<br></br>
3 Temmuz Tarihinde 2 Grup Halinde "YYS Güvenlim Eğitimi"<br></br>
<br></br>
Çalışmaları Gerçekleşmiştir.
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>




          <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/KuzeyBoru2.jpg" alt="Member " />
                          <Link
                            to="#"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          14 Haziran 2025 Tarihinde Malatya OSB'de Bulunan Kuzey Boru Firmamızın YYS Süreçleri Kapsamında İlgili Personele Yönelik "Tedarik Güvenliği Eğitimini" Gerçekleştir
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>


  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/KuzeyBoru.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DLNuKOLsaMn/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          11 Haziran 2025 Tarihinde Konya Aksaray'da Bulunan Güçlü  Borsa Firmamız Kuzey Boru Firmamızda YYS Süreçleri Kapsamında İlgili Personele Yönelik "Tedarik Güvenliği Eğitimini" 2 Grup Halinde Gerçekleştir
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>


  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/colins.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DKh7OBGMkSf/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          3 Haziran 2025 günü Türkiye'nin Önde Gelen Jeans Markası Colin's in Kıraç'ta Bulunan Dağıtım Merkezinde İlgili Personellere Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/bogaz-ici-unv4.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DKSbgIusTU1/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          30 Mayıs 2025 günü Boğaziçi Üniversitesinde İlgili Personele Yönelik "Suçlu Profili İnceleme Eğitimini Kırmızı Yalıda Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>

  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/Pegasus.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DKIG93rsGRX/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          26 Mayıs 2025 günü YYS Süreçleri Kapsamında Pegasus Hava Yollarındaki İlgili Personellere Yönelik "YYS Güvenlik Eğitimini" Online Platformda Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>

  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/fortrans.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DJ__aRkMfUj/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          23 Mayıs 2025 günü 2022  Yılından bu yana YYS Süreçlerinde Çözüm Ortaklığı Yaptığımız Fortrans Lojistikte İlgili Personele Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>






  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/smc.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DHO2OPOsscY/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          18 Nisan 2025 Günü Japon Otomotiv Yedek Parça Devi SMC Türkiye Şirketinde İlgili Personele Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>








          <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/ozdisan.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DHO2OPOsscY/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          15 Mart 2025 günü 1980 yilindan bu yana Türkiye'nin en büyük Elektronik Komponent Distribütörü ve PCB Dizgili Kart, TFT Panel, Alüminyum Sogutucu üreticisi Özdisan da İlgili Personele Yönelik "Tedarik Zinciri Güvenliği Eğitimini" Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>









<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/ABC-Lojistik-2025.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DFc9bJWM4x5/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          ABC Lojistik Firmamızda 2018, 2022 yılında gerçekleştirdiğimiz "YYS Güvenlik Eğitimimiz" Sonrasında 2025 Yılındaki hatırlatma Eğitimimizi de Kayseri Merkezde Gerçekleştirdik
                          </h5>
                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/bogaz-ici-unv3.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DCmdQpsM1Lb/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">20.11.2024 Günü Boğaziçi Üniversitesi'nde Devam Eden Eğitim Faaliyetlerimiz Kapsamında 3. Grup Özel Güvenlik Yönetici ve Personellerine Yönelik "Suçlu Profili İnceleme ve Tespiti Eğitimini" Tarihi Kırmızı Yalıda Gerçekleştirdik</h5>

                          </div>
                      </div>
                    </div>
                  </SwiperSlide>




<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/elslog.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/p/DChf3IqMbXz/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">18.11.2024 Günü Akşam Saatlerine Sürmesine Rağmen ELS Lojistik Depo, Sevkiyat ve Güvenlik Birimlerine Yeni Başlayan Personele Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik</h5>

                          </div>
                      </div>
                    </div>
                  </SwiperSlide>





<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/cybernicxfuture.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DBwiCIWsoaW/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">30 Ekim Çarşamba Günü Japonya 🇯🇵, İtalya 🇮🇹, Türkiye 🇹🇷 İşbirliği Çerçevesinde @mo_istanbul Otelde "Cybernicx Future Geleceğe Adım" Konferansını Gerçekleştirdik</h5>

                          </div>
                      </div>
                    </div>
                  </SwiperSlide>



<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/bogaz-ici-unv2.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DBMX4XuMMpB"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">17.10.2024 tarihinde Boğaziçi Üniversitesinde Devam Eden Eğitim Faaliyetlerimiz Kapsamında 2. Grup Özel Güvenlik Yönetici ve Personellerine Yönelik "Suçlu Profili İnceleme ve Tespiti Eğitimini" Tarihi Kırmızı Yalıda Gerçekleştirdik</h5>

                          </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  
<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/cok-yasar.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/p/DA1EIQAMY8k/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">07.10.2024 Günü Ülkemizin İhracat Devi ÇOKYAŞAR Holdingin İstanbul Silivri'de Bulunan Fabrikasında İlgili Yönetici Personele Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik</h5>

                          </div>
                      </div>
                    </div>
                  </SwiperSlide>

<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/cw-elek.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/p/DAwKek5McBg/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">Bugün Antalya'mızın En Büyük 4 Sanayi Kuruluşundan Biri Olan CW Enerji Şirketinin Antalya OSB Bulunan Fabrikasında İlgili Personele Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik</h5>

                          </div>
                      </div>
                    </div>
                  </SwiperSlide>









            <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/bogaz-ici-unv.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/DAGzb3Us3X3/?img_index=1"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">Bugün Boğaziçi Üniversitesi Özel Güvenlik Yönetici ve Personellerine Yönelik "Suçlu Profili İnceleme ve Tespiti Eğitimimizin" Giriş Eğitimi Bağaziçi Üniversitesi Güney Kampüsünde Tamamladık</h5>

                          </div>
                      </div>
                    </div>
                  </SwiperSlide>




<SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/yumak.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/securitr.as/p/C_gJVdysOLU/?img_index=1"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title"> 2023 & 2024 
                          Konya'mızın Güzide Firması @yumakautomotive de 2021 Yılında Gerçekleştirdiğimiz "YYS Güvenlik Eğitimini" Yeni Bir Belge Sürecinde Tekrarlama Fırsatı Bulduk. Dost Seviyesinde Misafirperverlikleri ve Eğitime Katılımları için YUMAK Ailesine Çok Teşekkür Ederim </h5>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>


                   <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/sumer-plastik.jpg" alt="Member " />
                          <Link
                            to="https://www.instagram.com/p/C-vLGdmsZG5/?img_index=1"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title"> Bugün Türkiye'nin İlk YYS Firmalarından  @sumerplastik Sultanbeyli Fabrikada Tekrarlama Eğitimleri Kapsamında İlgili Personele Yönelik "YYS Güvenlik Eğitimini" Gerçekleştirdik </h5>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>


                <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/logo/gumlnk.png" alt="Member " />
                          <Link
                            to="https://www.instagram.com/p/C322JkZsqwN/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title"> Gumlink ilgili personellerine yönelik "YYS Güvenlik Eğitimi" </h5>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={600}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/logo/kancaa.png" alt="Member " />
                          <Link
                            to="https://www.instagram.com/p/C3xzRXJMOks/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">Kanca ilgili Personele Yönelik "YYS Güvenlik Eğitimi" </h5>
                         
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5"
                        data-aos="fade-up"
                      >
                        <div className="team__image">
                          <img src="assets/imgs/logo/osloo.png" alt="securitr" />
                          <Link
                            to="https://www.instagram.com/p/C2NwS7-MGmm/?img_index=2"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          OSLO Gıda Personellere Yönelik YYS Güvenlik Eğitimi
                          </h5>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5"
                        data-aos="fade-up"
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/mega.png" alt="securitr" />
                          <Link
                            to="https://www.instagram.com/p/C03RE92MrPo/?img_index=1"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
                          Mega Metal Personellere Yönelik YYS Güvenlik Eğitimi
                          </h5>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/cwtinsta.png" alt="securitr" />
                          <Link
                            to="https://www.instagram.com/p/C0w1uRzM3fI/?img_index=2"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">CWT Turkey'de Tamamlanan Güvenlik Eğitimleri</h5>
                          
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={600}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/euro.png" alt="securitr" />
                          <Link
                            to="https://www.instagram.com/p/Cz_mlUIsTQr/?img_index=2"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title"> @euroturkfreight Personellere Yönelik "YYS Güvenlik Eğitimi"</h5>
                          
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5"
                        data-aos="fade-up"
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/assetig.png" alt="Member" />
                          <Link
                            to="https://www.instagram.com/p/Czyyj7qMYxv/?img_index=1"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">
 @assetgli  Personellere Yönelik "YYS Güvenlik Eğitimi"</h5>
                          
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={300}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/superfresh.png" alt="Member " />
                          <Link
                            to="https://www.instagram.com/p/CyS3rBUMjC1/?img_index=2"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">Superfresh Personellere Yönelik YYS Güvenlik Eğitimi</h5>
                   
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="swiper-slide">
                      <div
                        className="team__member team-member-5 pt-0"
                        data-aos="fade-up"
                        data-aos-delay={600}
                      >
                        <div className="team__image">
                          <img src="assets/imgs/instagram/popart.png" alt="Member " />
                          <Link
                            to="https://www.instagram.com/p/Cx2eBQistx8/"
                            target="_blank"
                          >
                            <div className="share__wrap">
                              <button className="share-btn">
                                <i className="fa-brands fa-instagram" />
                              </button>
                            </div>
                          </Link>
                        </div>
                        <div className="team__content">
                          <h5 className="team__title">@lalemuzesi Sergisinin Koruma ve Gözetim Görevi</h5>
                         
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                 
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Team area end */}
    </>
  );
};

export default TeamFour;
